module.exports = __webpack_public_path__ + "static/media/delete-white.46632909.svg";